import { render } from "./HisApplications.vue?vue&type=template&id=b670ac5e"
import script from "./HisApplications.vue?vue&type=script&lang=js"
export * from "./HisApplications.vue?vue&type=script&lang=js"

import "./HisApplications.vue?vue&type=style&index=0&id=b670ac5e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__